const SOCIAL_TITLE_RE = /:\s*r\/|\br\/\w+/i
const CONVERSATIONAL_RE = /^(satisfied|legit check|just (got|bought|received)|check out|send your|how to)/i
const EDITORIAL_RE = /\b(announces|annonce que|next generation of|sold out|%\s?off)\b/i

export function isUsableProductName(name) {
  const text = String(name || '').trim()
  if (!text) return false
  if (SOCIAL_TITLE_RE.test(text) || CONVERSATIONAL_RE.test(text) || EDITORIAL_RE.test(text)) return false
  return true
}

export function displayProductName(name, fallback = 'Produit à identifier') {
  return isUsableProductName(name) ? textOrFallback(name, fallback) : fallback
}

function textOrFallback(name, fallback) {
  return String(name || '').trim() || fallback
}

export function sourceKindLabel(kind) {
  if (kind === 'manufacturer') return 'Fiche fabricant'
  if (kind === 'commerce') return 'Page marchande'
  if (kind === 'social') return 'Publication'
  if (kind === 'support') return 'Page d’assistance'
  return 'Autre mention'
}
